import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { HomeIcon, CalendarCheckIcon, UsersIcon, CreditCardIcon, SettingsIcon, BellIcon, MenuIcon, LogOutIcon, SearchIcon, ChevronDownIcon } from 'lucide-react';
const MainLayout = ({
  onLogout
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const navItems = [{
    title: 'Dashboard',
    icon: <HomeIcon size={20} data-id="element-21" />,
    path: '/'
  }, {
    title: 'Duty Management',
    icon: <CalendarCheckIcon size={20} data-id="element-22" />,
    path: '/duties'
  }, {
    title: 'Lawajam Management',
    icon: <CreditCardIcon size={20} data-id="element-23" />,
    path: '/lawajam'
  }, {
    title: 'Member Management',
    icon: <UsersIcon size={20} data-id="element-24" />,
    path: '/members'
  }, {
    title: 'Settings',
    icon: <SettingsIcon size={20} data-id="element-25" />,
    path: '/settings'
  }, {
    title: 'Notifications',
    icon: <BellIcon size={20} data-id="element-26" />,
    path: '/notifications'
  }];
  const logout = () => {
    // Call the onLogout function passed from App component
    onLogout();
    // Navigate to login page
    navigate('/login');
  };
  return <div className="flex h-screen bg-gray-100" data-id="element-27">
      {/* Sidebar */}
      <aside className={`bg-blue-800 text-white ${collapsed ? 'w-16' : 'w-64'} transition-all duration-300 ease-in-out`} data-id="element-28">
        <div className="p-4 flex items-center justify-between" data-id="element-29">
          {!collapsed && <div className="font-bold text-xl" data-id="element-30">Burhani Guards</div>}
          <button onClick={() => setCollapsed(!collapsed)} className="p-1 rounded-md hover:bg-blue-700" data-id="element-31">
            <MenuIcon size={20} data-id="element-32" />
          </button>
        </div>
        <nav className="mt-6" data-id="element-33">
          {navItems.map((item, index) => <NavLink key={index} to={item.path} className={({
          isActive
        }) => `flex items-center p-4 ${isActive ? 'bg-blue-700' : 'hover:bg-blue-700'} transition-colors`} data-id="element-34">
              <div className="mr-3" data-id="element-35">{item.icon}</div>
              {!collapsed && <span data-id="element-36">{item.title}</span>}
            </NavLink>)}
        </nav>
      </aside>
      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-37">
        {/* Top bar */}
        <header className="bg-white shadow-sm z-10" data-id="element-38">
          <div className="flex items-center justify-between p-4" data-id="element-39">
            <div className="flex items-center rounded-md bg-gray-100 px-3 py-2 w-64" data-id="element-40">
              <SearchIcon size={18} className="text-gray-500" data-id="element-41" />
              <input type="text" placeholder="Search..." className="bg-transparent border-none outline-none ml-2 w-full" data-id="element-42" />
            </div>
            <div className="flex items-center space-x-4" data-id="element-43">
              <button className="relative p-1" data-id="element-44">
                <BellIcon size={20} data-id="element-45" />
                <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full" data-id="element-46"></span>
              </button>
              <div className="flex items-center space-x-2 cursor-pointer" data-id="element-47">
                <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white font-medium" data-id="element-48">
                  AD
                </div>
                <div className="hidden md:block" data-id="element-49">
                  <div className="text-sm font-medium" data-id="element-50">Admin User</div>
                  <div className="text-xs text-gray-500" data-id="element-51">Super Admin</div>
                </div>
                <ChevronDownIcon size={16} data-id="element-52" />
              </div>
              <button onClick={logout} className="p-2 hover:bg-gray-100 rounded-md text-gray-600" data-id="element-53">
                <LogOutIcon size={20} data-id="element-54" />
              </button>
            </div>
          </div>
        </header>
        {/* Page content */}
        <main className="flex-1 overflow-auto p-6" data-id="element-55">
          <Outlet data-id="element-56" />
        </main>
      </div>
    </div>;
};
export default MainLayout;